/**
 * Created by Victor Rojo on 19/9/18.
 */
import {Component, Input, OnDestroy} from '@angular/core';

import {PumpWidget} from "../../widget/Widget";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {Pump} from "../../ipetrol/Pump";
import {Globals} from '../../../globals';

@Component({
  selector: 'pump',
  templateUrl: './Pump.component.html',
  styleUrls: ['./Pump.component.css']
})
export class PumpComponent extends WidgetStatusChangeAware{
  currencySymbol = "EUR";
  volumeUnit = "L";
  tenant = "";
  locale = "";
  status:string = "";
  subscriptions: any[] = [];
  salesInfo:boolean = true;

  constructor(private iPlaceDataChangeService1: IPlaceDataChangeService, private globals: Globals) {
    super(iPlaceDataChangeService1);
    this.subscriptions.push(this.iPlaceDataChangeService1.pumpChange$.subscribe( (pump:Pump) => {
      let pumpWidget = this._widget as PumpWidget;
      if ( pump.pumpId == pumpWidget.pumpId ) {
        pumpWidget.status = pump.status;
        pumpWidget.mode = pump.mode;
        pumpWidget.volumeToday = pump.volumeToday;
        pumpWidget.moneyToday = pump.moneyToday;
        pumpWidget.volumeTotal = pump.volumeTotal;
        pumpWidget.moneyTotal = pump.moneyTotal;
        pumpWidget.updated = pump.updated;
        pumpWidget.fuellingOptions = pump.fuellingOptions;
        this.updateStatus();
      }
    }));

    this.setVolumeUnit();
    this.setCurrencySymbol();
    this.setTenant();
  }

  private setTenant() {
    this.tenant = this.globals.tenant;
  }

  private setVolumeUnit() {
    if (this.globals.tenant === "ecuador") {
      this.volumeUnit = "gal";
    }
  }

  private setCurrencySymbol() {
    if (this.globals.tenant === "ecuador") {
       this.currencySymbol = "USD";
       this.locale = "en-US";
    }
  }

  get widget(): PumpWidget {
    return this._widget as PumpWidget;
  }

  @Input()
  set widget(pumpWidget: PumpWidget) {
    this._widget = pumpWidget;
    this.updateStatus();
    this.salesInfo = pumpWidget.salesInfo;
  }

  updateStatus(){
    let pumpWidget = this._widget as PumpWidget;
    if ( pumpWidget.status && pumpWidget.status == "online"){
      this.status = "ON";
    } else {
      this.status = "OFF";
    }
  }

  getFuellingOptionClass(fuellingOption:any) {
    if ( fuellingOption ) {
      return fuellingOption.status ? "active" : "inactive";
    }
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
